var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBnpBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 201.43826,
    width: 923.07684,
    viewBox: "-35.92941 -13.067825 239.52938 19.7427",
    id: "svg25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs17"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    spreadMethod: "pad",
    gradientTransform: "matrix(0,56.112075,-56.112075,0,-8.8918929,-30.382122)",
    gradientUnits: "userSpaceOnUse",
    id: "a",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007348",
    id: "stop1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8dc9ab",
    id: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00925b",
    id: "stop3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    spreadMethod: "pad",
    gradientTransform: "matrix(0,63.054537,-63.054537,0,-8.9755179,-42.278997)",
    gradientUnits: "userSpaceOnUse",
    id: "b",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00925b",
    id: "stop4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8dc9ab",
    id: "stop5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00925b",
    id: "stop6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8352,
    stopColor: "#007348",
    id: "stop7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009c6d",
    id: "stop8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    spreadMethod: "pad",
    gradientTransform: "matrix(0,-40.80375,40.80375,0,1.1244821,17.293378)",
    gradientUnits: "userSpaceOnUse",
    id: "c",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a678",
    id: "stop9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00925b",
    id: "stop10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    spreadMethod: "pad",
    gradientTransform: "matrix(0,-40.816075,40.816075,0,-24.192018,17.295628)",
    gradientUnits: "userSpaceOnUse",
    id: "d",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a678",
    id: "stop11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00925b",
    id: "stop12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    spreadMethod: "pad",
    gradientTransform: "matrix(0,-40.78925,40.78925,0,-16.305643,17.286503)",
    gradientUnits: "userSpaceOnUse",
    id: "e",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a678",
    id: "stop13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00925b",
    id: "stop14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    spreadMethod: "pad",
    gradientTransform: "matrix(0,-40.8033,40.8033,0,-9.4870179,17.292253)",
    gradientUnits: "userSpaceOnUse",
    id: "f",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a678",
    id: "stop15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00925b",
    id: "stop16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,42.52 H 623.622 V 85.04 H 0 Z",
    id: "path16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,42.52 H 623.622 V 85.04 H 0 Z",
    id: "path17"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m -35.468893,23.195378 h 53.155 v -52.27125 h -53.155 z",
    fill: "url(#a)",
    id: "path18",
    style: {
      fill: "url(#a)",
      strokeWidth: 1.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -31.316393,-28.139622 c -1.03125,0 -1.705,0.87 -1.865,2.09 0,0 -1.3275,6.9775 -1.3275,21.7937495 0,14.8237505 1.3275,24.5225005 1.3275,24.5225005 0.1225,1.1725 0.83375,2.08875 1.865,2.08875 h 46.00875 c 1.0275,0 1.845,-0.815 1.8625,-2.08875 0,0 -0.51125,-11.3600005 -0.51125,-22.4550005 0,-11.0962495 0.51125,-23.8612495 0.51125,-23.8612495 0.025,-1.135 -0.835,-2.09 -1.8625,-2.09 z",
    fill: "url(#b)",
    id: "path19",
    style: {
      fill: "url(#b)",
      strokeWidth: 1.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -5.4776429,-22.807122 c 1.45125,0.60875 7.28375,3.7625 7.99875,4.77 -2.93500003,0.3875 -8.69125,1.88625 -11.79125,3.395 l -0.18125,0.365 c 3.41875,-0.7525 8.1975,-1.14625 11.4925,-1.325 -1.23000003,1.805 -2.04500003,2.665 -3.91625,4.7075 l -0.17375,0.39625 c 3.56625,-2.1425 4.57,-2.29625 7.8575,-4.22125 1.24125,1.83625 1.54,6.0674995 1.5875,9.4212495 1.07,-2.1275 2.36875,-10.1424995 1.82875,-11.5912495 2.1799999,-1.49625 2.4749999,-2.70125 2.4749999,-2.70125 -1.9987499,0.1725 -3.1012499,0.20625 -4.1787499,0.54625 -2.55375,-1.56625 -8.41000003,-3.6325 -12.83,-4.1325 z",
    fill: "url(#c)",
    id: "path20",
    style: {
      fill: "url(#c)",
      strokeWidth: 1.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -27.252643,2.1003775 c -0.28875,2.67 -0.405,4.58 -0.0225,6.71625 -1.08125,0.29875 -2.02875,0.34125 -2.9,0.7125 l -0.16625,0.36625 c 1.38625,0.8550005 2.515,1.5100005 4.0825,2.2412505 0.83875,1.80125 1.705,3.01625 3.11,4.40375 l 0.17125,-0.37125 c -0.2525,-1.02375 -0.58,-1.87 -0.45625,-2.98875 1.7425,0.5075 3.2375,0.77625 5.22375,0.83625 l 0.1675,-0.37125 c -1.74625,-0.6775 -3.49125,-1.21125 -4.90375,-2.54375 0.44375,-1.2350005 0.9525,-2.2037505 1.7825,-3.4287505 l 0.175,-0.375 c -1.5,0.22625 -2.86,0.775 -4.1575,1.0275 -1.0225,-1.7975 -1.42,-4.25625 -1.935,-6.59875 z",
    fill: "url(#d)",
    id: "path21",
    style: {
      fill: "url(#d)",
      strokeWidth: 1.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -18.352643,-10.085872 c 0,0 -1.1225,-0.1075 -2.98,-0.05125 -1.57,0.0725 -3.91125,0.2124995 -5.05,0.5474995 l -0.16625,0.365 c 1.81,0.0775 4.29,0.56375 5.23875,1.51625 0,0 -2.7475,2.47875 -5.47125,7.90375004 0,0 4.9375,-4.63250004 7.0775,-5.78125004 0,0 1.12,3.73 1.8975,5.59750004 l 0.17125,-0.3725 c 0.215,-1.20000004 0.75125,-4.45500004 1.66125,-6.44625004 0,0 0.3225,-0.19625 1.90125,-0.35 1.5825,-0.14125 3.82,-0.225 8.0687501,0.52125 l 0.1725,-0.365 c -0.97,-0.5725 -4.8362501,-2.23 -8.9287501,-2.78125 h 0.13375 c 0.56125,-1.6524995 1.26375,-2.8987495 1.26375,-2.8987495 -0.8675,0.1225 -3.3375,1.2775 -4.99,2.595",
    fill: "url(#e)",
    id: "path22",
    style: {
      fill: "url(#e)",
      strokeWidth: 1.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -8.0101429,12.800378 c -0.06125,-0.72375 -0.1075,-1.34 -0.14375,-2.155 -0.85875,1.165 -1.5925,2.08125 -2.5400001,3.145 -1.00125,0.27875 -2.14625,0.2675 -3.19,0.25625 -0.4125,-0.005 -0.81125,-0.0087 -1.1775,0.0025 l -0.16875,0.37125 c 0.97125,0.5 1.925,0.8075 2.9425,1.01625 -0.825,0.75125 -1.9275,1.3225 -2.7025,1.84625 l -0.17,0.365 c 1.66,-0.3925 3.84625,-1.0975 5.4750001,-2.05875 0.8475,0.0375 1.63875,-0.01875 2.22,-0.13375 0,0 0.17375,-0.37875 0.17375,-0.37 -0.10625,-0.375 -0.44,-0.60375 -0.5375,-1.12875 1.52625,-1.185 2.6325,-2.265 3.90875,-3.54875 l 0.1775,-0.3725 c -1.26125,0.87 -2.7925,2.06625 -4.2675,2.765",
    fill: "url(#f)",
    id: "path23",
    style: {
      fill: "url(#f)",
      strokeWidth: 1.25
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "matrix(1.25,0,0,-1.25,-89.291393,76.345378)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 76.215,73.152 c -2.624,-1.543 -3.428,-1.673 -6.282,-3.381 1.662,1.803 2.24,2.571 3.268,4.08 -2.631,-0.14 -6.454,-0.456 -9.184,-1.061 2.376,1.269 7.087,2.68 9.574,3.016 -0.577,0.796 -5.244,3.324 -6.405,3.811 3.695,-0.287 8.211,-1.668 10.401,-3.007 0.861,0.269 1.757,0.282 3.36,0.425 -0.408,-0.701 -0.426,-1.107 -1.999,-2.15 0.436,-1.165 -0.605,-7.574 -1.465,-9.271 -0.031,2.681 -0.265,6.067 -1.268,7.538 M 56.9987,50.1597 c -1.508,0.559 -2.594,1.21 -3.79,2.328 0.358,0.988 0.767,1.76 1.433,2.75 -1.226,-0.183 -2.13,-0.321 -3.186,-0.521 -0.86,1.504 -1.25,2.957 -1.688,4.978 -0.234,-2.142 -0.323,-3.672 -0.021,-5.377 -0.969,-0.269 -1.656,-0.505 -2.454,-0.864 1.118,-0.684 2.021,-1.211 3.269,-1.793 0.671,-1.439 1.364,-2.411 2.49,-3.52 -0.264,0.945 -0.334,1.696 -0.226,2.687 1.395,-0.406 2.589,-0.619 4.173,-0.668 m 3.9262,21.3158 c -0.47,-0.61 -1.015,-1.747 -1.162,-2.275 3.887,-0.527 7.006,-2.523 7.006,-2.523 -3.399,0.603 -5.19,0.528 -6.458,0.414 -1.26,-0.119 -1.519,-0.267 -1.519,-0.267 -0.917,-2.009 -1.467,-5.459 -1.467,-5.459 -0.618,1.491 -1.512,4.477 -1.512,4.477 -1.715,-0.917 -5.659,-4.628 -5.659,-4.628 2.168,4.344 4.369,6.32 4.369,6.32 -0.757,0.767 -2.743,1.15 -4.196,1.214 0.754,0.308 2.689,0.668 4.175,0.736 1.488,0.043 2.388,-0.042 2.388,-0.042 1.327,1.048 3.341,1.93 4.035,2.033 m 4.123,-18.6229 c -0.686,-0.931 -1.276,-1.662 -2.037,-2.513 -1.308,-0.367 -2.352,-0.503 -3.627,-0.503 0.783,-0.404 1.541,-0.646 2.358,-0.817 -0.817,-0.739 -1.507,-1.265 -2.3,-1.77 1.329,0.315 3.076,0.879 4.377,1.648 0.68,-0.026 1.315,0.018 1.781,0.11 -0.122,0.394 -0.196,0.688 -0.295,1.201 1.225,0.948 2.114,1.807 3.134,2.839 -1.085,-0.757 -2.021,-1.322 -3.277,-1.915 -0.054,0.578 -0.085,1.068 -0.114,1.72",
    fill: "#ffffff",
    id: "path24"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.25,0,0,-1.25,-96.199149,64.602193)",
    id: "g25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 101.0941,68.3088 c 2.603,-0.022 3.556,-0.551 3.556,-1.968 0,-0.391 -0.12,-0.738 -0.35,-1.003 -0.499,-0.599 -1.47,-0.91 -2.708,-0.832 h -0.064 l -0.727,-1.894 h 0.727 c 1.437,0.041 2.686,-0.412 3.328,-1.196 0.296,-0.357 0.445,-0.787 0.445,-1.225 0,-1.482 -1.305,-2.247 -3.879,-2.247 -0.433,0 -1.138,0 -1.576,0.014 -0.074,1.978 -0.107,4.654 -0.107,5.461 0,0.933 0.061,3.013 0.107,4.79 0.297,0.061 0.79,0.1 1.248,0.1 m -4.821,1.362 c 0.08,-1.405 0.162,-4.957 0.162,-6.252 0,-1.194 -0.001,-5.19 -0.21,-6.913 l -0.013,-0.135 h 6.243 c 3.069,0 6.314,0.954 6.314,3.68 0,1.705 -1.235,2.966 -3.545,3.656 1.714,0.46 2.855,1.631 2.855,2.97 0,2.225 -2.555,3.062 -4.957,3.12 h -6.885 z m 26.9052,0.1264 h -3.038 l 0.123,-3.386 c 0.059,-1.673 0.116,-3.394 0.234,-5.065 -0.196,0.524 -0.379,0.793 -1.303,2.137 -0.003,0.047 -3.161,4.904 -4.257,6.283 l -0.031,0.031 h -3.525 v -0.126 c 0.112,-1.405 0.157,-4.958 0.157,-6.253 0,-1.194 0,-5.189 -0.168,-6.912 l -0.031,-0.136 h 3.142 v 0.136 c -0.179,3.277 -0.179,6.584 -0.179,9.792 0.109,-0.389 0.248,-0.723 0.743,-1.456 0.041,-0.087 5.452,-7.964 5.715,-8.415 l 0.027,-0.057 h 2.517 l -0.004,0.136 c -0.192,1.723 -0.208,5.718 -0.208,6.912 0,1.295 0.086,4.848 0.168,6.253 l 0.04,0.126 z m 8.2396,-1.6203 c 1.751,0.032 2.973,-0.322 3.554,-1.057 0.266,-0.316 0.413,-0.733 0.413,-1.211 0,-1.943 -2.186,-2.365 -4.013,-2.365 l -0.742,0.042 c 0,0 -0.175,0.017 -0.305,0.031 -0.013,0.449 -0.013,1.041 -0.013,1.705 0,0.845 0,1.848 0.039,2.777 0.258,0.034 0.647,0.078 1.067,0.078 m -4.607,1.494 c 0.123,-1.405 0.17,-4.957 0.17,-6.253 0,-1.193 0,-5.189 -0.184,-6.912 v -0.136 h 3.737 l -0.016,0.136 c -0.128,1.24 -0.193,3.604 -0.206,5.411 l 0.706,-0.036 0.528,-0.011 c 4.916,0 7.307,1.301 7.307,4.039 0,3.115 -3.354,3.83 -6.15,3.888 h -5.892 z m 23.7762,-1.494 c 1.755,0.032 2.976,-0.322 3.564,-1.057 0.27,-0.316 0.405,-0.733 0.405,-1.211 0,-1.943 -2.183,-2.365 -3.987,-2.365 l -0.74,0.042 c 0,0 -0.196,0.017 -0.311,0.031 -0.02,0.449 -0.02,1.044 -0.02,1.705 0,0.853 0,1.848 0.035,2.777 0.234,0.034 0.638,0.078 1.054,0.078 m -4.6,1.494 c 0.118,-1.405 0.186,-4.957 0.186,-6.253 0,-1.193 -0.012,-5.189 -0.206,-6.912 v -0.136 h 3.74 l -0.022,0.136 c -0.119,1.24 -0.187,3.604 -0.187,5.411 0.174,-0.009 0.673,-0.036 0.673,-0.036 l 0.542,-0.011 c 4.914,0 7.326,1.301 7.326,4.039 0,3.115 -3.373,3.83 -6.18,3.888 h -5.872 z M 163.947,65.843 c 0.297,-0.64 1.069,-2.425 1.937,-4.555 -0.134,-0.006 -0.302,-0.006 -0.302,-0.006 l -1.635,-0.022 c 0,0 -1.692,0.022 -1.975,0.028 0.706,1.703 1.405,3.242 1.975,4.555 m -0.909,3.954 h -0.049 l -0.026,-0.067 c -0.696,-1.911 -5.179,-11.694 -5.889,-13.192 l -0.059,-0.168 h 3.183 l 0.027,0.074 c 0.28,0.921 0.657,1.959 1.067,3.067 0.127,0 2.655,0.038 2.655,0.038 l 2.199,-0.016 c 0,0 0.354,-0.022 0.46,-0.022 0.566,-1.443 1.001,-2.531 1.19,-3.084 l 0.036,-0.057 h 3.689 l -5.959,13.427 h -0.074 z m 9.9822,-0.1258 c 0.107,-1.405 0.161,-4.958 0.161,-6.253 0,-1.194 0,-5.189 -0.204,-6.912 v -0.136 h 3.76 l -0.016,0.136 c -0.199,1.735 -0.213,5.718 -0.213,6.912 0,0.933 0.029,3.013 0.122,4.695 0.286,0.02 0.72,0.064 1.014,0.064 1.74,0.032 2.969,-0.327 3.544,-1.057 0.276,-0.317 0.4,-0.743 0.4,-1.211 0,-1.551 -1.447,-2.337 -2.796,-2.407 -0.452,-0.019 -0.788,0.039 -0.788,0.039 l -0.262,0.045 0.144,-0.246 c 1.335,-1.947 3.331,-5.318 4.156,-6.913 l 0.023,-0.057 h 4.017 l -0.1,0.181 c -0.164,0.226 -2.78,4.077 -3.892,5.722 0,0 -0.048,0.047 -0.097,0.099 2.06,0.619 3.055,1.77 3.055,3.537 0,3.092 -3.354,3.828 -6.186,3.888 h -5.853 z m 18.3779,0.126 h -3.581 l 0.02,-0.126 c 0.093,-1.405 0.165,-4.958 0.165,-6.253 0,-1.188 -0.016,-5.177 -0.185,-6.912 l -0.014,-0.136 h 3.712 l -0.019,0.136 c -0.143,1.735 -0.187,5.724 -0.187,6.912 0,1.295 0.089,4.848 0.187,6.253 v 0.126 z m 8.3202,-1.4884 c 2.622,-0.022 3.576,-0.551 3.576,-1.968 0,-0.391 -0.121,-0.738 -0.359,-1.003 -0.473,-0.599 -1.482,-0.91 -2.712,-0.832 h -0.061 l -0.722,-1.894 h 0.722 c 1.442,0.041 2.68,-0.412 3.321,-1.196 0.313,-0.357 0.462,-0.787 0.462,-1.225 0,-1.482 -1.311,-2.247 -3.899,-2.247 -0.415,0 -1.115,0 -1.553,0.014 -0.107,1.978 -0.107,4.654 -0.107,5.461 0,0.933 0.033,3.013 0.107,4.79 0.283,0.061 0.774,0.1 1.225,0.1 m -4.819,1.362 c 0.107,-1.405 0.172,-4.957 0.172,-6.252 0,-1.194 0,-5.19 -0.188,-6.913 l -0.03,-0.135 h 6.253 c 3.057,0 6.313,0.954 6.313,3.68 0,1.705 -1.238,2.966 -3.568,3.656 1.717,0.46 2.872,1.631 2.872,2.97 0,2.225 -2.56,3.062 -4.94,3.12 h -6.9 z m 20.1685,-3.8205 c 0.301,-0.625 1.067,-2.413 1.936,-4.548 -0.132,0 -0.294,-0.014 -0.294,-0.014 l -1.642,-0.022 c 0,0 -1.712,0.036 -1.966,0.036 0.696,1.715 1.377,3.243 1.966,4.548 m 1.545,3.947 h -2.514 l -0.015,-0.06 c -0.751,-2.033 -5.487,-12.332 -5.885,-13.186 l -0.069,-0.181 h 3.199 l 0.02,0.08 c 0.267,0.92 0.639,1.953 1.055,3.083 0.102,0 2.644,0.04 2.644,0.04 l 2.203,-0.035 c 0,0 0.383,-0.005 0.468,-0.005 0.578,-1.443 1.007,-2.54 1.194,-3.083 l 0.034,-0.08 h 3.702 l -5.955,13.427 z m 7.0837,-3.4722 c 0,-2.359 2.363,-3.308 4.455,-4.176 1.629,-0.649 3.333,-1.332 3.333,-2.457 0,-0.34 -0.067,-0.626 -0.257,-0.827 -0.392,-0.462 -1.185,-0.656 -2.444,-0.586 -1.247,0.05 -2.653,0.443 -4.235,1.172 l -0.619,0.298 v -2.925 l 0.422,-0.108 0.246,-0.042 c 0.781,-0.194 2.29,-0.549 3.788,-0.549 3.943,0 6.296,1.573 6.296,4.173 0,2.442 -2.429,3.391 -4.576,4.247 -1.581,0.641 -3.218,1.276 -3.218,2.323 0,0.302 0,1.183 2.043,1.183 1.505,0 2.968,-0.613 3.799,-0.931 l 0.758,-0.317 -0.005,0.504 v 2.432 l -0.753,0.136 c -0.766,0.155 -2.044,0.409 -3.36,0.409 -3.402,0 -5.673,-1.606 -5.673,-3.959",
    id: "path25"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "25.7329px",
      fontFamily: "Calibri",
      InkscapeFontSpecification: "'Calibri, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "start",
      writingMode: "lr-tb",
      direction: "ltr",
      textAnchor: "start",
      fill: "#000000",
      strokeWidth: 1.37854
    },
    x: 20.853615,
    y: 17.966345,
    id: "text25",
    transform: "scale(1.1019396,0.90749075)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan25",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "25.7329px",
      fontFamily: "Calibri",
      InkscapeFontSpecification: "'Calibri, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      strokeWidth: 1.37854
    },
    x: 20.853615,
    y: 17.966345
  }, "BUSINESS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnpBusiness);
export default __webpack_public_path__ + "static/media/bnp-business.660f69b5e6f778e670c8e7b69f35ca86.svg";
export { ForwardRef as ReactComponent };